import { color } from "@styles";
import { Cloud } from "components/atoms/Cloud";
import { FC } from "react";

export const Clouds: FC = () => (
  <>
    <Cloud
      id="GCI-hero-cloud1"
      color={color.S320}
      scale={1.83}
      reversed
      top="18%"
      left="14%"
      animated
    />
    <Cloud
      id="GCI-hero-cloud2"
      color={color.S320}
      reversed
      top="33%"
      right="38%"
      animated
      hideOnMobile
    />
    <Cloud
      id="GCI-hero-cloud3"
      color={color.S320}
      scale={1.1}
      bottom="34%"
      right="10%"
      animated
      hideOnMobile
    />
    <Cloud id="GCI-hero-cloud5" color={color.S320} scale={1.37} bottom="15%" left="60%" animated />
  </>
);
